import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { getImgxUrl } from "../LazyImage";
import { KDEFAULT_AVATAR_PATH, KDEFAULT_AVATAR_URL, KSIZE_MAPPER } from "./constants";
export var getAvatarSrc = function getAvatarSrc(_ref) {
  var srcProp = _ref.src,
    sizeProp = _ref.size;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!srcProp) return {};
  var baseImgxParams = {
    auto: 'format',
    crop: 'faces',
    dpr: 2
  };
  var size = KSIZE_MAPPER[sizeProp];
  return {
    src: getImgxUrl(srcProp, _objectSpread({
      w: size,
      h: size
    }, baseImgxParams))
  };
};
export var getDefaultAvatarSrc = function getDefaultAvatarSrc(_ref2) {
  var color = _ref2.defaultAvatarColor,
    sizeProp = _ref2.size;
  var size = KSIZE_MAPPER[sizeProp];
  var baseUrl = KDEFAULT_AVATAR_URL + KDEFAULT_AVATAR_PATH[color];
  return getImgxUrl(baseUrl, {
    w: size,
    h: size
  });
};